/**
 * Quick Add Sizes — Stradivarius / Fatma Atasoy UX
 *
 * Desktop: Click a size on hover overlay → instant AJAX add to cart → toast
 * Mobile:  Tap bag icon → bottom sheet → select size → tap "SEPETE EKLE" → toast
 *
 * Integrates with the Prestige theme's cart event system:
 *   - Dispatches  cart:change  so CartCount + CartDrawer update
 *   - Uses  baseEvent:"quick-add"  so the drawer does NOT auto-open
 */
(function () {
  'use strict';

  /* ------------------------------------------------
     DESKTOP — size button click → instant add
     ------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quick-add-sizes__btn');
    if (!btn || btn.disabled) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    e.preventDefault();
    e.stopPropagation();
    addToCart(variantId, btn);
  });

  /* ------------------------------------------------
     MOBILE — bottom sheet (lazy-created, shared)
     ------------------------------------------------ */
  var sheet = null;
  var sheetOverlay = null;
  var selectedVariantId = null;

  function ensureSheet() {
    if (sheet) return;

    // Overlay
    sheetOverlay = document.createElement('div');
    sheetOverlay.className = 'quick-add-sheet-overlay';
    sheetOverlay.addEventListener('click', closeSheet);

    // Panel
    sheet = document.createElement('div');
    sheet.className = 'quick-add-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'Beden Seçimi');
    sheet.innerHTML =
      '<div class="quick-add-sheet__handle"></div>' +
      '<button class="quick-add-sheet__close" aria-label="Kapat">&times;</button>' +
      '<span class="quick-add-sheet__title">BEDENLER</span>' +
      '<div class="quick-add-sheet__sizes"></div>' +
      '<button class="quick-add-sheet__add-btn" disabled>SEPETE EKLE</button>';

    sheet.querySelector('.quick-add-sheet__close').addEventListener('click', closeSheet);

    sheet.querySelector('.quick-add-sheet__add-btn').addEventListener('click', function () {
      if (!selectedVariantId) return;
      var addBtn = this;
      addToCart(selectedVariantId, addBtn, function () {
        closeSheet();
      });
    });

    // Swipe-to-dismiss
    var startY = 0;
    var currentY = 0;
    var dragging = false;

    sheet.addEventListener('touchstart', function (e) {
      startY = e.touches[0].clientY;
      currentY = startY;
      dragging = true;
    }, { passive: true });

    sheet.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      currentY = e.touches[0].clientY;
      var diff = currentY - startY;
      if (diff > 0) {
        sheet.style.transform = 'translateY(' + diff + 'px)';
        sheet.style.transition = 'none';
      }
    }, { passive: true });

    sheet.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      sheet.style.transition = '';
      var diff = currentY - startY;
      if (diff > 80) {
        closeSheet();
      } else {
        sheet.style.transform = '';
      }
    });

    document.body.appendChild(sheetOverlay);
    document.body.appendChild(sheet);
  }

  function openSheet(productCard) {
    ensureSheet();

    var dataEl = productCard.querySelector('.quick-add-data');
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); }
    catch (err) { console.error('[QuickAdd] JSON parse error', err); return; }

    selectedVariantId = null;

    var sizesWrap = sheet.querySelector('.quick-add-sheet__sizes');
    var addBtn = sheet.querySelector('.quick-add-sheet__add-btn');
    addBtn.disabled = true;
    sizesWrap.innerHTML = '';

    var variants = data.variants;
    var sizePos = data.sizeOptionPosition;
    var sizeValues = data.sizeValues;

    function getSizeFromVariant(v) {
      if (sizePos === 1) return v.option1;
      if (sizePos === 2) return v.option2;
      if (sizePos === 3) return v.option3;
      return null;
    }

    var items = [];
    if (sizeValues && sizeValues.length > 0) {
      sizeValues.forEach(function (name) {
        var available = variants.find(function (v) {
          return getSizeFromVariant(v) === name && v.available;
        });
        items.push({
          label: name,
          variantId: available ? available.id : null,
          available: !!available
        });
      });
    } else {
      // No dedicated size option → show full variant titles
      variants.forEach(function (v) {
        items.push({
          label: v.title,
          variantId: v.id,
          available: v.available
        });
      });
    }

    items.forEach(function (item) {
      var btn = document.createElement('button');
      btn.className = 'quick-add-sheet__size-btn' + (item.available ? '' : ' quick-add-sheet__size-btn--disabled');
      btn.textContent = item.label;
      btn.disabled = !item.available;
      if (item.variantId) btn.dataset.variantId = item.variantId;

      btn.addEventListener('click', function () {
        if (this.disabled) return;
        // Deselect siblings
        sizesWrap.querySelectorAll('.quick-add-sheet__size-btn--selected').forEach(function (b) {
          b.classList.remove('quick-add-sheet__size-btn--selected');
        });
        this.classList.add('quick-add-sheet__size-btn--selected');
        selectedVariantId = this.dataset.variantId;
        addBtn.disabled = false;
      });

      sizesWrap.appendChild(btn);
    });

    // Animate open
    requestAnimationFrame(function () {
      sheetOverlay.classList.add('quick-add-sheet-overlay--open');
      sheet.classList.add('quick-add-sheet--open');
      sheet.style.transform = '';
      document.body.classList.add('quick-add-sheet-no-scroll');
    });
  }

  function closeSheet() {
    if (!sheet) return;
    sheetOverlay.classList.remove('quick-add-sheet-overlay--open');
    sheet.classList.remove('quick-add-sheet--open');
    document.body.classList.remove('quick-add-sheet-no-scroll');
    selectedVariantId = null;
  }

  // Mobile trigger tap
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.quick-add-mobile-trigger');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var card = trigger.closest('product-card') || trigger.closest('.product-card');
    if (card) openSheet(card);
  });

  // Escape key closes sheet
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sheet && sheet.classList.contains('quick-add-sheet--open')) {
      closeSheet();
    }
  });

  /* ------------------------------------------------
     AJAX ADD TO CART
     ------------------------------------------------ */
  function addToCart(variantId, triggerEl, onSuccess) {
    if (!variantId) return;

    // Loading state
    if (triggerEl) triggerEl.classList.add('quick-add-sizes__btn--loading', 'quick-add-sheet__add-btn--loading');

    // Collect bundled section IDs so CartDrawer content updates
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (sectionsToBundle.length) {
      formData.append('sections', sectionsToBundle.join(','));
      formData.append('sections_url', window.Shopify.routes.root + 'variants/' + variantId);
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed: ' + res.status);
        return res.json();
      })
      .then(function (addResponse) {
        // Redirect if cart type is "page"
        if (window.themeVariables && window.themeVariables.settings.cartType === 'page') {
          window.location.href = window.Shopify.routes.root + 'cart';
          return;
        }

        // Fetch full cart for event
        return fetch(window.Shopify.routes.root + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            cart.sections = addResponse.sections || {};

            // Dispatch cart:change → updates CartCount + CartDrawer + opens drawer
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: {
                baseEvent: 'variant:add',
                onSuccessDo: 'force_open_drawer',
                cart: cart
              }
            }));

            // Build variant title for toast
            var items = addResponse.hasOwnProperty('items') ? addResponse.items : [addResponse];
            var variantTitle = items[0] && items[0].variant_title ? items[0].variant_title : '';

            showToast(variantTitle);

            if (typeof onSuccess === 'function') onSuccess();
          });
      })
      .catch(function (err) {
        console.error('[QuickAdd]', err);
        // Optionally show error feedback
        showToast(null, true);
      })
      .finally(function () {
        if (triggerEl) {
          triggerEl.classList.remove('quick-add-sizes__btn--loading', 'quick-add-sheet__add-btn--loading');
        }
      });
  }

  /* ------------------------------------------------
     TOAST NOTIFICATION (Stradivarius-style top bar)
     ------------------------------------------------ */
  var toastTimer = null;

  function showToast(variantTitle, isError) {
    // Remove previous
    var prev = document.querySelector('.quick-add-toast');
    if (prev) {
      clearTimeout(toastTimer);
      prev.remove();
    }

    var message = isError
      ? 'Ürün sepete eklenemedi'
      : (variantTitle ? variantTitle + ' sepete eklendi' : 'Sepete eklendi');

    var iconSvg = isError
      ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>'
      : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>';

    var toast = document.createElement('div');
    toast.className = 'quick-add-toast';
    toast.innerHTML =
      '<div class="quick-add-toast__content">' + iconSvg + '<span>' + message + '</span></div>' +
      '<a href="' + window.Shopify.routes.root + 'cart" class="quick-add-toast__link quick-add-toast__cart-link">SEPETİ GÖRÜNTÜLE →</a>';

    // Try to open cart drawer instead of navigating
    var cartLink = toast.querySelector('.quick-add-toast__cart-link');
    cartLink.addEventListener('click', function (e) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.show === 'function') {
        e.preventDefault();
        toast.classList.remove('quick-add-toast--visible');
        setTimeout(function () { toast.remove(); }, 350);
        drawer.show();
      }
    });

    document.body.appendChild(toast);

    // Trigger animation (double rAF for reliable transition)
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.classList.add('quick-add-toast--visible');
      });
    });

    toastTimer = setTimeout(function () {
      toast.classList.remove('quick-add-toast--visible');
      setTimeout(function () { toast.remove(); }, 400);
    }, 4500);
  }
})();
